(function() {
  'use strict';

  const SELECTORS = {
    section: '[data-handwritten-note-section]',
    input: '[data-handwritten-note-input]',
    button: '[data-handwritten-checkout-button]',
    warning: '[data-handwritten-checkout-warning]',
    form: '[data-handwritten-checkout-form]'
  };

  const DISABLED_CLASSES = ['opacity-50', 'cursor-not-allowed'];

  function init() {
    updateAllForms();
    bindInputListeners();
    bindCartUpdateListeners();
  }

  function updateAllForms() {
    const forms = document.querySelectorAll(SELECTORS.form);
    forms.forEach(updateFormState);
  }

  function updateFormState(form) {
    const button = form.querySelector(SELECTORS.button);
    const warning = form.querySelector(SELECTORS.warning);
    if (!button) return;

    // Find the relevant note input. Could be in same parent (drawer) or elsewhere on page (cart page)
    const scope = form.closest('[data-cart-page], [data-cart-drawer], cart-drawer, body') || document;
    const section = scope.querySelector(SELECTORS.section);
    const input = scope.querySelector(SELECTORS.input);

    // No handwritten note in cart = no validation needed
    if (!section || !input) {
      enableButton(button, warning);
      return;
    }

    const value = (input.value || '').trim();
    if (value.length === 0) {
      disableButton(button, warning);
    } else {
      enableButton(button, warning);
    }
  }

  function disableButton(button, warning) {
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    DISABLED_CLASSES.forEach(cls => button.classList.add(cls));
    if (warning) warning.classList.remove('hidden');
  }

  function enableButton(button, warning) {
    button.disabled = false;
    button.removeAttribute('aria-disabled');
    DISABLED_CLASSES.forEach(cls => button.classList.remove(cls));
    if (warning) warning.classList.add('hidden');
  }

  function bindInputListeners() {
    document.addEventListener('input', function(e) {
      if (e.target.matches(SELECTORS.input)) {
        updateAllForms();
      }
    });
  }

  function bindCartUpdateListeners() {
    // Re-check whenever cart changes (item added, removed, quantity updated)
    document.addEventListener('cart:updated', updateAllForms);
    document.addEventListener('cart:refresh', updateAllForms);

    // Fallback: observe DOM changes in case cart re-renders
    const observer = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          updateAllForms();
          break;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();